import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil";
import { covenantsFetchState, covenantsState, professionalsBySpecialityState, professionalsState, serviciosState, specialitiesFetchState, specialitiesState, sucursalesFetchState, sucursalesState, tipoExamenState } from "../components/autocompletes/state/atoms";
import { filterSearchSelectedState } from "../state/atoms";
import { useState } from "react";
import TipoExamenService from "src/services/agenda/tipoExamen";
import procedimientoService from "src/services/agenda/procedimientos";

const useLoadData = () => {
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const setSucursales = useSetRecoilState(sucursalesState);
  const setSpecialities = useSetRecoilState(specialitiesState);
  const setProfessionals = useSetRecoilState(professionalsState);
  const setCovenants = useSetRecoilState(covenantsState);
  const setTipoExamen = useSetRecoilState(tipoExamenState);
  const setServicio = useSetRecoilState(serviciosState);
  const [loadingData, setLoadingData] = useState(false);

  const sucursales = useRecoilValue(sucursalesState);

  const loadData = useRecoilCallback(
    ({ snapshot }) =>
      async (tab) => {
        const release = snapshot.retain();
        setLoadingData(true);
        try {
          if (tab === 1 || tab === 4) {
            const sucursalesFetch = snapshot.getPromise(sucursalesFetchState);
            const specialitiesFetch = snapshot.getPromise(
              specialitiesFetchState
            );
            const professionalsFetch = snapshot.getPromise(
              professionalsBySpecialityState(
                filterSearchSelected.specialitySelected.value
              )
            );
            const covenantsFetch = snapshot.getPromise(covenantsFetchState);

            const responses = await Promise.all([
              sucursalesFetch,
              specialitiesFetch,
              professionalsFetch,
              covenantsFetch,
            ]);

            setSucursales(responses[0]);
            setSpecialities(responses[1]);
            setProfessionals(responses[2]);
            setCovenants(responses[3]);
          }

          if (tab === 2 || tab === 4) {
            const sue_correl = filterSearchSelected.sucursalSelected.sue_correl;
            const tipoExamenesFetch = await TipoExamenService.getAll(
              sue_correl
            );
            setTipoExamen(tipoExamenesFetch.data.data);
          }

          if (tab === 3 || tab === 4) {
            const reduceSueCorrel = sucursales.reduce((acc, item, idx, src) => {
              if (idx === src.length - 1) {
                acc = acc + item.sueCorrel;
              } else {
                acc = acc + item.sueCorrel + "_";
              }
              return acc;
            }, "");
            const servicioFetch = await procedimientoService.getServicios(
              reduceSueCorrel
            );
            setServicio(servicioFetch.data.data);
          }
        } catch (error) {
          // handle error
        } finally {
          setLoadingData(false);
          release();
        }
      },
    [filterSearchSelected]
  );

  return { loadData, loadingData };
};

export default useLoadData;
